<template lang="pug">
    v-stepper(v-model="e1")
      v-snackbar(
        v-model="snackbar"
        :timeout="10000"
        color='error'
      ) {{ snackbarMessage }}
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
        v-divider
        v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus
  
      v-stepper-items
        v-stepper-content(step="1")
              v-layout(row wrap)
                v-flex(xs4 sm3)
                  p(class="inputH") 
                    span(class="mustFill") *
                    span  Judul Pekerjaan
                v-flex(xs7 sm5)
                  v-text-field(id="fik-judul-pekerjaan" class="inputDefault" v-model='judulPekerjaan' label="Judul Pekerjaan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="inputH") 
                    span(class="mustFill") *
                    span  Lokasi Pekerjaan
                v-flex(xs7 sm5)
                 v-row
                   v-col
                     v-autocomplete(
                        class="inputDefault"
                        label="Lokasi Pekerjaan" 
                        v-model="lokasi" 
                        :items="locations.data"
                        id="fik-lokasi-kerja"
                        no-data-text="No Data" 
                        color="blue-grey lighten-2" 
                        item-text="location_name" 
                        item-value="data" 
                        clearable
                        chips
                        multiple)
                   v-col
                    v-text-field(id="fik-sub-lokasi" class="inputDefault" v-model='subLokasi' label="Sub Lokasi" counter="100" maxlength="100" height='42')
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="inputH") 
                    span(class="mustFill") *
                    span  Department
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                        class="inputDefault"
                        v-model="deptDivisi"
                        :items="dataUsers.department"
                        id="fik-dept-divisi"
                        label="Department")
                    v-col
                      v-text-field(id="fik-divisi" class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
                v-flex(xs1 sm4)

                v-flex(xs3 sm3) 
                  p(class="inputH") 
                    span(class="mustFill") *
                    span  Tanggal Perizinan
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="startMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="startDate"
                        label="mulai dari"
                        prepend-icon="event"
                        id="fik-tgl-izin-start"
                        readonly
                        v-on="on")
                    v-date-picker(id="fik-tgl-picker-start" v-model="startDate" @input="clearDate" :min="todayDate")
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="endMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="endDate"
                        label="sampai dengan"
                        prepend-icon="event"
                        id="fik-tgl-izin-end"
                        readonly
                        v-on="on")
                    v-date-picker(id="fik-tgl-picker-end" v-model="endDate" @input="endMenu = false" :min="startDate" :max="maxEndDate")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="inputH") 
                    span(class="mustFill") *
                    span  Perusahaan
                v-flex(xs7 sm5)
                  v-autocomplete(
                    class="inputDefault"
                    v-model="perusahaan"
                    :items="dataUsers.companies"
                    id="fik-perusahaan"
                    label="Perusahaan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="inputH") 
                    span(class="mustFill") *
                    span  Nama Pemegang Izin
                v-flex(xs7 sm5)
                  v-menu(
                    v-model="searchPemegangMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="pemegangIzin.name"
                        label="Pemegang Izin"
                        id="fik-pemegang-izin"
                        readonly
                        v-on="on")
                    PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin")
                v-flex(xs1 sm4)
              v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
              v-btn(text @click="backHome()") Cancel
        v-stepper-content(step="2")
              v-layout(row wrap)
                v-flex(xs12 sm12) 
                    p(class="inputH") Peralatan yang Digunakan
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="fik-details-pekerjaan" :editor="editor" v-model="PeralatanDigunakan" :config="editorConfig")
                    br

                v-flex(xs12 sm12) 
                    p(class="inputH") Potensi Bahaya / Risiko Yang Mungkin Ada
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="fik-bahaya" :editor="editor" v-model="bahaya" :config="editorConfig")
                    br
              v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
              v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
              v-btn(text @click="backHome()") Cancel
  
        v-stepper-content(step="3")
            v-layout(row wrap)
              v-flex(xs12 sm12) 
                p(class="headerSection") Daftar Periksa
              <div class="upload-progress mb-5">
                <div class="progress-header">
                    <span class="headTitle">Progres Unggah Daftar Periksa</span>
                    <div>
                        <span class="percent">{{ totalProgressPercent }}%</span>
                        <span class="detail-uploaded">({{ uploadedCount }}/{{ totalDocuments }} Dokumen Terunggah)</span>
                    </div>
                </div>
                <v-progress-linear :value="totalProgressPercent"></v-progress-linear>
              </div>

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 1. Lampiran Gambar / Denah Lokasi Pekerjaan
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docPendukungDenah)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docPendukungDenah")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docPendukungDenah)")
                span(id="fik-document") {{docPendukungDenah.name ? docPendukungDenah.name : docName(docPendukungDenah) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocPendukungDenah','docPendukungDenah')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 2. Identifikasi Instalasi Kabel Listrik Melintang
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docPendukungKabelListrik)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docPendukungKabelListrik")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docPendukungKabelListrik)")
                span(id="fik-document") {{docPendukungKabelListrik.name ? docPendukungKabelListrik.name : docName(docPendukungKabelListrik) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocPendukungKabelListrik','docPendukungKabelListrik')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 3. Prosedur Kerja (PPO/AKA) ada?
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docPpoAka)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docPpoAka")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docPpoAka)")
                span(id="fik-document") {{docPpoAka.name ? docPpoAka.name : docName(docPpoAka) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocPpoAka','docPpoAka')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 4. Dipasang penanda/rambu pada kabel melintang?
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docRambuKabel)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docRambuKabel")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docRambuKabel)")
                span(id="fik-document") {{docRambuKabel.name ? docRambuKabel.name : docName(docRambuKabel) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocRambuKabel','docRambuKabel')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 5. Area kerja sudah dibarrikade?
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docBarrikade)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docBarrikade")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docBarrikade)")
                span(id="fik-document") {{docBarrikade.name ? docBarrikade.name : docName(docBarrikade) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocBarrikade','docBarrikade')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 6. Terdapat pengawasan melekat?
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docPengawasan)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docPengawasan")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docPengawasan)")
                span(id="fik-document") {{docPengawasan.name ? docPengawasan.name : docName(docPengawasan) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocPengawasan','docPengawasan')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 7. Rencana penyelamatan & peralatan ditetapkan?
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docPenyelamatan)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docPenyelamatan")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docPenyelamatan)")
                span(id="fik-document") {{docPenyelamatan.name ? docPenyelamatan.name : docName(docPenyelamatan) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocPenyelamatan','docPenyelamatan')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH")
                  span(class="mustFill") * 
                  span 8. Foto peralatan / unit yang digunakan
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docPeralatanUnit)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docPeralatanUnit")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docPeralatanUnit)")
                span(id="fik-document") {{docPeralatanUnit.name ? docPeralatanUnit.name : docName(docPeralatanUnit) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocPeralatanUnit','docPeralatanUnit')")
                  v-icon mdi-close

              v-flex(xs5 sm6)
                p(class="inputH mb-10")
                  span.with-indent 9. Document pendukung (Optional)
              v-flex(xs6 sm5 class="attachment" v-if="isInvalidFile(docPendukungOpt)")
                v-file-input(id="fik-document" accept=".pdf,.jpg,.jpeg,.png,.tif" :rules="rules"  label="Unggah PDF, JPG, PNG atau TIF (max 2 MB)" v-model="docPendukungOpt")
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="!isInvalidFile(docPendukungOpt)")
                span(id="fik-document") {{docPendukungOpt.name ? docPendukungOpt.name : docName(docPendukungOpt) }}
                v-btn(icon color="red" @click="openDeleteDialog('deletedocPendukungOpt','docPendukungOpt')")
                  v-icon mdi-close

              v-flex(xs12 sm12) 
                p(class="inputH") Pengendalian Risiko Tambahan
              v-flex( sm12)
                div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fik-pengendalian-resiko" :editor="editor" v-model="pengendalianRisikoTambahan" :config="editorConfig")
                br
            
              v-flex(xs12 sm12) 
                p(class="inputH") Catatan Penting Lainnya
              v-flex( sm12)
                div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fik-catatan-penting" :editor="editor" v-model="catatanPentingLain" :config="editorConfig")
                br
            v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
            v-btn(class="mr-3" color='info' @click='submit(1)')
                v-icon insert_drive_file
                | &nbsp; Save as Draft
            v-btn(v-if='!submitClick' color='success' @click='submit(2)')
                v-icon send
                | &nbsp; Submit Request
            v-btn(text @click="backHome()") Cancel

            v-dialog(v-model="deleteDialog" max-width="400")
             v-card
              v-card-title(class="headline") Confirmation
               v-card-text
                | Are you sure you want to delete this file?
              v-card-actions
                v-spacer
                v-btn(text @click="deleteDialog = false") Batal
                v-btn(color="red" text @click="confirmDelete") Hapus

            <AlertDialogDocumentUpload v-model="alertDialog" />
            
  </template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import PemegangModal from "./PemegangModal.vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import helper from "../helper";
import AlertDialogDocumentUpload from "./AlertDialogDocumentUpload.vue";
import { getMaxEndDate } from "../helper/getMaxDate";
import { handleError } from "../helper/handleGlobalError.js";

const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/tiff'
];

const MAX_FILE_SIZE = 2000000;

export default {
  name: "AddKelistrikan",
  components: {
    PemegangModal,
    AlertDialogDocumentUpload
  },
  props: {
    edit: { type: Boolean, default: false },
    users: Array
  },
  data() {
    return {
      alertDialog: false,
      deleteDialog: false,
      deleteAction: null,
      deleteParam: null,
      e1: 1,
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        removePlugins: ['ImageUpload', 'MediaEmbed'],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],
          styles: [
            // This option is equal to a situation where no style is applied.
            'full',
            // This represents an image aligned to the left.
            'alignLeft',
            // This represents an image aligned to the right.
            'alignRight'
          ]
        }
      },
      formCode: 'BIB-HSE-PPO-FRM-IZIN-KELISTRIKAN',
      todayDate: new Date().toISOString().slice(0, 10),
      perusahaan: '',
      judulPekerjaan: '',
      deptDivisi: '',
      divisi: '',
      lokasi: '',
      subLokasi: '',
      pemegangIzin: '',

      searchPemegangMenu: false,
      startDate: null,
      endDate: null,
      startMenu: false,
      endMenu: false,
      startDateExtend: new Date().toISOString().substr(0, 10),
      endDateExtend: new Date().toISOString().substr(0, 10),
      startMenuExtend: false,
      endMenuExtend: false,

      denahLokasi: '',
      instalasiListrik: '',
      ppoAka: '',
      rambuKabel: '',
      barrikade: '',
      pengawasan: '',
      penyelamatan: '',
      peralatanUnit: '',

      pengendalianRisikoTambahan: '',
      catatanPentingLain: '',
      PeralatanDigunakan: '',
      bahaya: '',

      //FOR DOCUMENT UPLOAD
      uploadId: null,
      docPendukungDenah: null,
      docPendukungKabelListrik: null,
      docPpoAka: null,
      docRambuKabel: null,
      docBarrikade: null,
      docPengawasan: null,
      docPenyelamatan: null,
      docPeralatanUnit: null,
      docPendukungOpt: null,
      snackbar: false,
      snackbarMessage: '',

      submitClick: false,
      rules: [
        value => {
          console.log(value)
          if (!value) return true;

          const files = Array.isArray(value) ? value : [value];

          for (let file of files) {

            if (!ALLOWED_FILE_TYPES.includes(file.type)) {
              return 'Format file harus PDF, JPG, PNG, atau TIF!';
            }

            if (file.size >= MAX_FILE_SIZE) {
              return 'Ukuran file harus dibawah 2 MB!';
            }

          }

          return true;
        }
      ],
      status: 0,

      requiredDocuments: [
        "docPendukungDenah",
        "docPendukungKabelListrik",
        "docPpoAka",
        "docRambuKabel",
        "docBarrikade",
        "docPengawasan",
        "docPenyelamatan",
        "docPeralatanUnit"
      ],

      uploadProgress: {}
    };
  },
  mounted: async function () {
    this.$store.dispatch("fetchLocations");
    this.uploadId = Date.now();
  },
  computed: {
    ...mapState(["API_URL", "API_URL_REVAMP", "locations", "dataUsers", "dataEditRequest"]),
    selectedLoc() {
      let tempLoc = []
      let locationCode;

      if (this.dataUsers.location instanceof Array) {
        locationCode = this.dataUsers.location[0];
      } else {
        locationCode = this.dataUsers.location;
      }

      for (let i = 0; i < this.lokasi.length; i++) {
        tempLoc.push({ code: locationCode, name: this.lokasi[i] });
      }
      return tempLoc
    },
    isPage1Complete: function () {
      return !!this.judulPekerjaan && !!this.deptDivisi && !!this.divisi && this.subLokasi && !!this.perusahaan && (this.selectedLoc.length != 0) && !!this.pemegangIzin && !(this.selectedLoc.length < 1) && !!this.startDate && !!this.endDate;
    },
    isDocComplete: function () {
      return !!this.docPendukungDenah && !!this.docPendukungKabelListrik && !!this.docPpoAka && !!this.docRambuKabel && !!this.docBarrikade && !!this.docPengawasan && !!this.docPenyelamatan && !!this.docPeralatanUnit
    },
    uploadedCount() {
      return this.requiredDocuments.filter(
        doc => this.uploadProgress[doc] === 100
      ).length;
    },

    totalDocuments() {
      return this.requiredDocuments.length;
    },

    totalProgressPercent() {
      if (this.totalDocuments === 0) return 0;
      return Math.round(
        (this.uploadedCount / this.totalDocuments) * 100
      );
    },
    maxEndDate() {
      return getMaxEndDate(this.startDate, 7)
    }
  },
  methods: {
    isInvalidFile(file) {
      if (!file) return true;

      if (typeof file === 'string') return false;

      if (!ALLOWED_FILE_TYPES.includes(file.type)) return true;

      if (file.size > MAX_FILE_SIZE) return true;

      return false;
    },
    openDeleteDialog(actionName, param) {
      this.deleteAction = actionName;
      this.deleteParam = param;
      this.deleteDialog = true;
    },

    confirmDelete() {
      if (!this.deleteAction) return;

      // panggil function dynamic
      this[this.deleteAction](this.deleteParam);

      this.deleteDialog = false;
      this.deleteAction = null;
      this.deleteParam = null;
    },
    clearDate() {
      this.startMenu = false;
      this.endDate = null;
    },
    formatDate: helper.formatDate,
    scrollTop() {
      window.scrollTo(0, 0);
    },
    backHome() {
      this.$router.push('/');
    },
    backStep() {
      this.e1--
    },
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    async submit(status) {
      this.submitClick = true;
      this.status = status;

      if (this.status === 2) {
        if (!this.isDocComplete) {
          this.submitClick = false
          return this.alertDialog = true
        }
      }

      let formData = new FormData();
      if (this.edit) {
        formData.append('_id', this.dataEditRequest._id);
        formData.append('ipNo', this.dataEditRequest.ipNo);
        formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
      }
      formData.append('ipStatus', this.status);
      formData.append('ipPerusahaan', this.perusahaan);
      formData.append('ipLocation', JSON.stringify(this.selectedLoc));
      formData.append('ipSubLokasi', this.subLokasi);
      formData.append('ipPemegangIzin', JSON.stringify(this.pemegangIzin));
      formData.append('ipJudulPekerjaan', this.judulPekerjaan);
      formData.append('ipDeptDivisi', this.deptDivisi);
      formData.append('ipDivisi', this.divisi);

      formData.append('ipPelaksanaanStart', this.startDate);
      formData.append('ipPelaksanaanEnd', this.endDate);

      formData.append('ipDenahLokasi', this.docPendukungDenah ? 'Ya' : 'Tidak');
      formData.append('ipInstalasiListrik', this.docPendukungKabelListrik ? 'Ya' : 'Tidak');
      formData.append('ipPpoAka', this.docPpoAka ? 'Ya' : 'Tidak');
      formData.append('ipRambuKabel', this.docRambuKabel ? 'Ya' : 'Tidak');
      formData.append('ipBarikade', this.docBarrikade ? 'Ya' : 'Tidak');
      formData.append('ipPengawasan', this.docPengawasan ? 'Ya' : 'Tidak');
      formData.append('ipPenyelamatan', this.docPenyelamatan ? 'Ya' : 'Tidak');
      formData.append('ipPeralatanUnit', this.docPeralatanUnit ? 'Ya' : 'Tidak');

      formData.append('ipPengendalianRisikoTambahan', this.pengendalianRisikoTambahan);
      formData.append('ipCatatanPentingLain', this.catatanPentingLain);
      formData.append('ipPeralatanDigunakan', this.PeralatanDigunakan);
      formData.append('ipBahaya', this.bahaya);

      formData.append('uploadId', this.uploadId);
      formData.append('ipUser', JSON.stringify(this.dataUsers));
      formData.append('ipForm', this.formCode);

      try {
        await this.mergeDocument();

        const res = await axios({
          method: this.edit ? "put" : "post",
          url: `${this.API_URL}/v1/requests`,
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${this.$store.state.token}`
          },
          data: formData
        });

        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");

        this.$snackbar.showMessage({
          message: "Save success!",
          color: "green"
        });

      } catch (error) {

        console.error("Error:", error);

        const message =
          error.response?.data?.message ||
          error.message ||
          "Process failed!";

        this.$snackbar.showMessage({
          message,
          color: "blue-grey"
        });
      }
    },
    async mergeDocument() {
      try {
        const response = await axios({
          method: "post",
          url: `${this.API_URL_REVAMP}/merge-document`,
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
            "Content-Type": "application/json",
          },
          data: {
            uploadId: this.uploadId,
            status: this.status
          },
        });

        return response.data;
      } catch (error) {
        const message =
          error.response?.data?.message || "Failed to merge document";

        this.$snackbar.showMessage({
          message,
          color: "blue-grey",
        });

        throw error;
      }
    },

    async uploadFile(paramName, file) {
      try {
        if (!file || file.size > MAX_FILE_SIZE) return;

        this.$set(this.uploadProgress, paramName, 1);

        let formData = new FormData();
        formData.append("uploadId", this.uploadId);
        formData.append(paramName, file);

        await axios.post(
          `${this.API_URL_REVAMP}/attachments/${paramName}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`
            },
            onUploadProgress: (e) => {
              if (e.total) {
                this.$set(
                  this.uploadProgress,
                  paramName,
                  Math.round((e.loaded * 100) / e.total)
                );
              }
            }
          }
        );

        this.$set(this.uploadProgress, paramName, 100);

      } catch (err) {
        this.$delete(this.uploadProgress, paramName);
        this[paramName] = null;
        handleError(err, {
            setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
            showSnackbar: (show) => { this.snackbar = show; },
            disableLoader: () => {
              this.$store.state.loader = false;
            },
            uploadFileError: true
          });
      }
    },
    docName(name) {
      return this.$setFilename(name);
    },
    deletedocPendukungDenah(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukungDenah = null;
          this.$set(this.uploadProgress, "docPendukungDenah", 0);
          this.denahLokasi = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocPendukungKabelListrik(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukungKabelListrik = null;
          this.$set(this.uploadProgress, "docPendukungKabelListrik", 0);
          this.instalasiListrik = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocPpoAka(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPpoAka = null;
          this.$set(this.uploadProgress, "docPpoAka", 0);
          this.ppoAka = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocRambuKabel(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docRambuKabel = null;
          this.$set(this.uploadProgress, "docRambuKabel", 0);
          this.rambuKabel = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocBarrikade(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docBarrikade = null;
          this.$set(this.uploadProgress, "docBarrikade", 0);
          this.barrikade = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocPengawasan(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPengawasan = null;
          this.$set(this.uploadProgress, "docPengawasan", 0);
          this.pengawasan = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocPenyelamatan(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPenyelamatan = null;
          this.$set(this.uploadProgress, "docPenyelamatan", 0);
          this.penyelamatan = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocPeralatanUnit(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPeralatanUnit = null;
          this.$set(this.uploadProgress, "docPeralatanUnit", 0);
          this.peralatanUnit = 'Tidak';
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    deletedocPendukungOpt(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukungOpt = null;
          this.$set(this.uploadProgress, "docPendukungOpt", 0);
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
  },
  watch: {
    // docPendukungDenah(params) {
    //   if (params && params.size < 2000000) {
    //     let formData = new FormData();
    //     formData.append('uploadId', this.uploadId);
    //     formData.append('docPendukungDenah', params);
    //     axios.post(`${this.API_URL}/v1/requests/attachmentKelistrikan/docPendukungDenah`, formData, { headers: { "Authorization": `Bearer ${this.$store.state.token}` } });
    //   }
    // },
    docPendukungDenah(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docPendukungDenah", file);
        this.denahLokasi = 'Ya';
      }
    },

    docPendukungKabelListrik(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docPendukungKabelListrik", file);
        this.instalasiListrik = 'Ya';
      }
    },
    docPpoAka(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docPpoAka", file);
        this.ppoAka = 'Ya';
      }
    },
    docRambuKabel(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docRambuKabel", file);
        this.rambuKabel = 'Ya';
      }
    },
    docBarrikade(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docBarrikade", file);
        this.barrikade = 'Ya';
      }
    },
    docPengawasan(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docPengawasan", file);
        this.pengawasan = 'Ya';
      }
    },
    docPenyelamatan(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docPenyelamatan", file);
        this.penyelamatan = 'Ya';
      }
    },
    docPeralatanUnit(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docPeralatanUnit", file);
        this.peralatanUnit = 'Ya';
      }
    },
    docPendukungOpt(file) {
      if (file && file.size < MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
        this.uploadFile("docPendukungOpt", file);
      }
    },
    dataEditRequest: async function () {
      console.log(this.dataEditRequest);
      this.perusahaan = this.dataEditRequest.ipPerusahaan;

      this.lokasi = [];
      for (const loc of this.dataEditRequest.ipLocation) {
        this.lokasi.push(loc.name);
      }
      this.subLokasi = this.dataEditRequest.ipSubLokasi;
      this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
      this.startDate = this.formatDate(this.dataEditRequest.ipPelaksanaanStart).slice(0, 10);
      this.endDate = this.formatDate(this.dataEditRequest.ipPelaksanaanEnd).slice(0, 10);
      this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan;
      this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
      this.divisi = this.dataEditRequest.ipDivisi;

      this.pengendalianRisikoTambahan = this.dataEditRequest.ipPengendalianRisikoTambahan;
      this.catatanPentingLain = this.dataEditRequest.ipCatatanPentingLain;
      this.PeralatanDigunakan = this.dataEditRequest.ipPeralatanDigunakan;
      this.bahaya = this.dataEditRequest.ipBahaya;

      this.uploadId = this.dataEditRequest.uploadId;
      this.docPendukungDenah = this.dataEditRequest.ipAttachmentFiles.docPendukungDenah;
      this.docPendukungKabelListrik = this.dataEditRequest.ipAttachmentFiles.docPendukungKabelListrik
      this.docPpoAka = this.dataEditRequest.ipAttachmentFiles.docPpoAka
      this.docRambuKabel = this.dataEditRequest.ipAttachmentFiles.docRambuKabel
      this.docBarrikade = this.dataEditRequest.ipAttachmentFiles.docBarrikade
      this.docPengawasan = this.dataEditRequest.ipAttachmentFiles.docPengawasan
      this.docPenyelamatan = this.dataEditRequest.ipAttachmentFiles.docPenyelamatan
      this.docPeralatanUnit = this.dataEditRequest.ipAttachmentFiles.docPeralatanUnit
      this.docPendukungOpt = this.dataEditRequest.ipAttachmentFiles.docPendukungOpt

      this.denahLokasi = this.dataEditRequest.ipDenahLokasi;
      this.instalasiListrik = this.dataEditRequest.ipInstalasiListrik;
      this.ppoAka = this.dataEditRequest.ipPpoAka;
      this.rambuKabel = this.dataEditRequest.ipRambuKabel;
      this.barrikade = this.dataEditRequest.ipBarikade;
      this.pengawasan = this.dataEditRequest.ipPengawasan;
      this.penyelamatan = this.dataEditRequest.ipPenyelamatan;
      this.peralatanUnit = this.dataEditRequest.ipPeralatanUnit;

      if (this.docPendukungDenah) {
        this.$set(this.uploadProgress, "docPendukungDenah", 100);
      }
      if (this.docPendukungKabelListrik) {
        this.$set(this.uploadProgress, "docPendukungKabelListrik", 100);
      }
      if (this.docPpoAka) {
        this.$set(this.uploadProgress, "docPpoAka", 100);
      }
      if (this.docRambuKabel) {
        this.$set(this.uploadProgress, "docRambuKabel", 100);
      }
      if (this.docBarrikade) {
        this.$set(this.uploadProgress, "docBarrikade", 100);
      }
      if (this.docPengawasan) {
        this.$set(this.uploadProgress, "docPengawasan", 100);
      }
      if (this.docPenyelamatan) {
        this.$set(this.uploadProgress, "docPenyelamatan", 100);
      }
      if (this.docPeralatanUnit) {
        this.$set(this.uploadProgress, "docPeralatanUnit", 100);
      }

    },
  }
};
</script>

<style scoped>
.ck-editor__editable {
  min-height: 300px;
  max-height: 300px;
  resize: none;
}

.mustFill {
  color: #EA5164;
}

.red {
  color: #EA5164;
}

.upload-progress {
  background: #F9F9F9;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;
  border-radius: 8px;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  width: 100%;
}

.headTitle {
  font-size: 14px;
}

.percent {
  font-size: 14px;
}

.inputH {
  margin-left: 20px;
  font-size: 15px;
}

.detail-uploaded {
  color: #9e9e9e;
  font-weight: 400;
  font-size: 14px;
  margin-left: 4px;
}

.with-indent {
  margin-left: 10px;
}
</style>